import { MouseEvent, RefObject } from 'react';
import { useTranslate } from 'i18n/useTranslationModules';
import { focusMainContent } from 'utils/focus-main-content';

import './skip-link.scss';

interface Props {
	targetRef?: RefObject<HTMLElement | null>;
}

export const SkipLink = ({ targetRef }: Props): JSX.Element => {
	const { t } = useTranslate('homepage');

	const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault();

		const target = targetRef?.current;
		if (!target) {
			focusMainContent();
			return;
		}

		if (!target.hasAttribute('tabindex')) {
			target.tabIndex = -1;
		}

		target.focus();
	};

	return (
		<a href="#main-content" className="skip-link" onClick={handleClick}>
			{t('Skip to content', 'Skip to content')}
		</a>
	);
};
